import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from "react";
import classNames from "classnames";
var css = {
  "appDrawerWrapper": "rui-oUQp0",
  "open": "rui-44DAo",
  "content": "rui-ULmxz",
  "close": "rui-kCNuu",
  "controls": "rui-SR3U7",
  "marker": "rui-ui7g0",
  "overlay": "rui-yTock"
};
var common = {
  "customScrollbar": "rui-caTsn"
};
export var defaultProps = {
  openHeight: 350,
  closeHeight: 45,
  drawerClass: "",
  controlsClass: "",
  overlayClass: "",
  enableToggleControl: true
};
var Drawer = /*#__PURE__*/function (_React$Component) {
  function Drawer(props) {
    var _this;
    _classCallCheck(this, Drawer);
    _this = _callSuper(this, Drawer, [props]);
    _this.toggleCollapse = function () {
      var _this$props = _this.props,
        propsOpen = _this$props.open,
        onToggle = _this$props.onToggle;
      var _this$state = _this.state,
        stateOpen = _this$state.open,
        controlledFromOutside = _this$state.controlledFromOutside;
      var open = controlledFromOutside ? propsOpen : stateOpen;
      if (open) {
        _this.contentRef.current.scrollTop = 0;
      }
      if (!controlledFromOutside) {
        _this.setState(function (state) {
          return {
            open: !state.open
          };
        });
      }
      onToggle ? onToggle() : null;
    };
    _this.contentRef = /*#__PURE__*/React.createRef();
    _this.state = {
      open: false,
      controlledFromOutside: Object.hasOwnProperty.call(_this.props, "open")
    };
    return _this;
  }
  _inherits(Drawer, _React$Component);
  return _createClass(Drawer, [{
    key: "render",
    value: function render() {
      var open = this.state.open;
      var _this$props2 = this.props,
        propsOpen = _this$props2.open,
        openHeight = _this$props2.openHeight,
        closeHeight = _this$props2.closeHeight,
        drawerClass = _this$props2.drawerClass,
        controlsClass = _this$props2.controlsClass,
        overlayClass = _this$props2.overlayClass,
        contentWrapperClass = _this$props2.contentWrapperClass,
        enableToggleControl = _this$props2.enableToggleControl;
      if (propsOpen !== undefined && propsOpen !== null) {
        open = propsOpen;
      }
      var uiState = open ? "open" : "close";
      var styles = {
        height: "".concat(open ? openHeight : closeHeight, "px")
      };
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: classNames(css.appDrawerWrapper, drawerClass, css[uiState])
      }, /*#__PURE__*/React.createElement("div", {
        className: classNames(css.content, common.customScrollbar, css[uiState], contentWrapperClass),
        style: styles,
        ref: this.contentRef
      }, this.props.children), enableToggleControl && (/*#__PURE__*/React.createElement("div", {
        className: classNames(css.controls, controlsClass, css[uiState]),
        onClick: this.toggleCollapse,
        onKeyPress: this.toggleCollapse,
        role: "button",
        tabIndex: 0
      }, /*#__PURE__*/React.createElement("div", {
        className: css.marker
      }, "\xA0")))), open && (/*#__PURE__*/React.createElement("div", {
        className: classNames(css.overlay, overlayClass, css[uiState]),
        onClick: this.toggleCollapse,
        onKeyPress: this.toggleCollapse,
        role: "button",
        tabIndex: 0
      }, "\xA0")));
    }
  }]);
}(React.Component);
Drawer.defaultProps = defaultProps;
export default Drawer;